export enum SocialOAuthProvider {
	Google = "google",
	Github = "github",
	Linkedin = "linkedin",
	Microsoft = "microsoft",
}

